import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/special_column_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  keyword: {
    model_name: 'SpecialColumn',
    column_type: 'string',
    column_name: 'title',
  },
}
export const formColumnsConfig = {
  'self': {
    'subtitle': { required: true, disabledUpdate: false },
    'title': { required: true, disabledUpdate: false },
    'content_type': { required: true, disabledUpdate: false },
    'content': { required: false, disabledUpdate: false },
    'markdown_content': { required: false, disabledUpdate: false },
    'cover': { required: true, disabledUpdate: false },
    'author': { required: true, disabledUpdate: false },
    'source': { required: true, disabledUpdate: false },
    'share_desc': { required: true, disabledUpdate: false },
    'note': { required: false, disabledUpdate: false },
    'special_column_article_relations': { required: false, disabledUpdate: false },
    'recommend_post_ids': { required: false, disabledUpdate: false },
  },
  'special_column_article_relations': {
    'article_id': { required: false, disabledUpdate: true },
    'position': { required: false, disabledUpdate: true },
    'id': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('SpecialColumn', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('SpecialColumn', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
